import ActionTypes from '../constants/ActionTypes';

const createCardRelation = (cardId, card2Id, type) => ({
  type: ActionTypes.CARD_RELATION_CREATE,
  payload: {
    cardId,
    card2Id,
    type,
  },
});

createCardRelation.success = (cardRelation) => ({
  type: ActionTypes.CARD_RELATION_CREATE__SUCCESS,
  payload: {
    cardRelation,
  },
});

createCardRelation.failure = (cardId, card2Id, type, error) => ({
  type: ActionTypes.CARD_RELATION_CREATE__FAILURE,
  payload: {
    cardId,
    card2Id,
    type,
    error,
  },
});

const handleCardRelationCreate = (cardRelation) => ({
  type: ActionTypes.CARD_RELATION_CREATE_HANDLE,
  payload: {
    cardRelation,
  },
});

const clearCardRelationCreateError = () => ({
  type: ActionTypes.CARD_RELATION_CREATE_ERROR_CLEAR,
});

const deleteCardRelation = (id) => ({
  type: ActionTypes.CARD_RELATION_DELETE,
  payload: {
    id,
  },
});

deleteCardRelation.success = (cardRelation) => ({
  type: ActionTypes.CARD_RELATION_DELETE__SUCCESS,
  payload: {
    cardRelation,
  },
});

deleteCardRelation.failure = (id, error) => ({
  type: ActionTypes.CARD_RELATION_DELETE__FAILURE,
  payload: {
    id,
    error,
  },
});

const handleCardRelationDelete = (cardRelation) => ({
  type: ActionTypes.CARD_RELATION_DELETE_HANDLE,
  payload: {
    cardRelation,
  },
});

export default {
  createCardRelation,
  handleCardRelationCreate,
  clearCardRelationCreateError,
  deleteCardRelation,
  handleCardRelationDelete,
};
